import React, { useEffect, useState } from "react";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import DateRangePicker from "react-bootstrap-daterangepicker";
import Chart from "react-apexcharts";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import CollapseHeader from "../../../core/common/collapse-header";
import { fetchRecentOrders,fetchOrderStatusSummary,fetchOrderSummary } from "../../../api/api";



interface RecentOrder {
  billno: string;
  order_status: string;
  order_note: string;
  date1: string;
  partyname: string;
  net_total: number;
  user: string;
  //?: string;
}

const OrderDashboard: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [recentOrders, setRecentOrders] = useState<RecentOrder[]>([]);
  const [selectedDays, setSelectedDays] = useState(30);


 // Get recent orders
const getRecentOrders = async (days: number) => {
  setLoading(true);

  try {
    const data = await fetchRecentOrders(days);

    if (Array.isArray(data)) {
      const formattedData = data.map((item: any) => ({
        billno: item.billno || "",
        order_status: item.order_status || "",
        order_note: item.order_note || "",
        date1: item.date1 || "",
        partyname: item.partyname || "",
        net_total: item.net_total || 0,
        user: item.user || "",
        voice_note: item.voice_note || "",
      }));
      setRecentOrders(formattedData);
    } else {
      console.error("Invalid data format:", data);
    }
  } catch (error) {
    console.error("Error fetching recent orders:", error);
  }

  setLoading(false); // always stop loading, even if there's an error
};

useEffect(() => {
  getRecentOrders(selectedDays);
}, [selectedDays]);
  
//pie chart 
useEffect(() => {
  fetchOrderStatusSummary(selectedDays).then((data) => {
    const normalizedData = data.map((d: any) => ({
      order_status: d.order_status
        ?.toLowerCase()
        .trim()
        .replace(/\r|\n/g, ""), //  removes hidden characters
      count: Number(d.count),
    }));

    const counts = chartOptions3.options.labels.map((label: string) => {
      const normalizedLabel = label.toLowerCase().trim().replace(/\r|\n/g, "");
      const match = normalizedData.find(
        (item: any) => item.order_status === normalizedLabel
      );
      return match ? match.count : 0;
    });

    setChartOptions3((prev: any) => ({
      ...prev,
      series: counts,
    }));

    console.log("Final Chart Counts:", counts);
  });
}, [selectedDays]);

//fetch live datas bar graph
// Fetch live data for bar graph
useEffect(() => {
  fetchOrderSummary().then((data) => {
    const normalizedData = data.map((d: any) => ({
      order_status: d.order_status?.toLowerCase().trim(),
      count: Number(d.count),
    }));

    const counts = chartOptions.xaxis.categories.map((label: string) => {
      const normalizedLabel = label.toLowerCase().trim();
      const match = normalizedData.find(
        (item: any) => item.order_status === normalizedLabel
      );
      return match ? match.count : 0;
    });

    setChartOptions((prev: any) => ({
      ...prev,
      series: [{ ...prev.series[0], data: counts }],
    }));

    console.log("Orders Status Data:", counts);
  });
}, []);

 
   // pie chart
    const [chartOptions3, setChartOptions3] = useState<any>({
    series: [],
    options: {
      chart: { width: 400, height: 300, type: "pie" },
      legend: { position: "bottom" },
      labels: [
        "Pending",
        "Customer Responded",
        "Approved",
        "On Work",
        "Completed",
        "Invoice Issued",
      ],
      colors: ["#FF0000", "#FFD700", "#89CFF0", "#FFA500", "#32CD32", "#4169E1"],
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: { width: 275 },
            legend: { position: "bottom" },
          },
        },
      ],
    },
  });

  // Area Chart - Completed Orders by Month
  const chartOptions4 = {
    series: [
      {
        name: "Completed Orders",
        data: [10, 20, 15, 30, 25, 35, 20, 40, 50, 45, 60, 55],
      },
    ],
    chart: { height: 273, type: "area" as const, zoom: { enabled: false } },
    colors: ["#4A00E5"],
    dataLabels: { enabled: false },
    stroke: { curve: "smooth" as const },
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
    },
    legend: { position: "top" as const, horizontalAlign: "left" as const },
  };

  // Bar Chart 1 - Orders by Stage
  const [chartOptions, setChartOptions] = useState<any>(  {
    series: [
      {
        name: "Order Count",
        data: [],
        color: "#FC0027",
      },
    ],
    chart: { type: "bar" as const, height: 250 },
    plotOptions: {
      bar: {
        horizontal: true,
        barHeight: "80%",
        borderRadius: 0,
        endingShape: "flat",
      },
    },
    dataLabels: { enabled: true },
    xaxis: {
      categories: ["Pending","Customer Responded", "Approved", "On Work",  "Completed", "Invoice Issued"],
    },
  });

  //Bar Chart 2 - Revenue by Category
  const chartOptions2 = {
    series: [
      {
        data: [400, 220, 448],
        color: "#77D882",
      },
    ],
    chart: { type: "bar" as const, height: 150 },
    plotOptions: { bar: { horizontal: true } },
    dataLabels: { enabled: false },
    xaxis: {
      categories: ["Electronics", "Furniture", "Clothing"],
      min: 0,
      max: 500,
    },
  };

  
  const initialSettings = {
    endDate: new Date("2020-08-11T12:30:00.000Z"),
    ranges: {
      "Last 30 Days": [
        new Date("2020-07-12T04:57:17.076Z"),
        new Date("2020-08-10T04:57:17.076Z"),
      ],
      "Last 7 Days": [
        new Date("2020-08-04T04:57:17.076Z"),
        new Date("2020-08-10T04:57:17.076Z"),
      ],
      "Last Month": [
        new Date("2020-06-30T18:30:00.000Z"),
        new Date("2020-07-31T18:29:59.999Z"),
      ],
      "This Month": [
        new Date("2020-07-31T18:30:00.000Z"),
        new Date("2020-08-31T18:29:59.999Z"),
      ],
      Today: [
        new Date("2020-08-10T04:57:17.076Z"),
        new Date("2020-08-10T04:57:17.076Z"),
      ],
      Yesterday: [
        new Date("2020-08-09T04:57:17.076Z"),
        new Date("2020-08-09T04:57:17.076Z"),
      ],
    },
    startDate: new Date("2020-08-04T04:57:17.076Z"),
    timePicker: false,
  };


  // 🟢 Status Colors
  const getStatusStyle = (status: string) => {
    const styles: Record<string, string> = {
      Pending: "#f39c12",
      Completed: "#27ae60",
      "On Work": "#3498db",
      Approved: "#9b59b6",
      Rejected: "#e74c3c",
    };
    return styles[status] || "#7f8c8d";
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        {/* Header */}
        <div className="row">
          <div className="col-md-12">
            <div className="page-header">
              <div className="row align-items-center">
                <div className="col-md-4">
                  <h3 className="page-title">Order Dashboard</h3>
                </div>
                <div className="col-md-8 float-end ms-auto">
                  <div className="d-flex title-head">
                    <div className="daterange-picker d-flex align-items-center justify-content-center">
                      <div className="form-sort me-2">
                        <i className="ti ti-calendar" />
                        <DateRangePicker initialSettings={initialSettings}>
                          <input
                            className="form-control bookingrange"
                            type="text"
                            placeholder="Select date range"
                          />
                        </DateRangePicker>
                      </div>
                      <div className="head-icons mb-0">
                        <CollapseHeader />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        
        <div className="row">
         
    {/* Recently Created Orders */}
    <div className="col-md-7">
      <div className="card">
        <div className="card-header border-0 pb-0">
          <div className="d-flex align-items-center justify-content-between">
            <h4>
              <i className="ti ti-grip-vertical me-1" />
              Recently Created Orders
            </h4>

            <div className="dropdown">
              <Link className="dropdown-toggle" data-bs-toggle="dropdown" to="#">
                <i className="ti ti-calendar-check me-2" />
                Last {selectedDays} days
              </Link>
              <div className="dropdown-menu dropdown-menu-end">
                <button className="dropdown-item" onClick={() => setSelectedDays(15)}>
                  Last 15 days
                </button>
                <button className="dropdown-item" onClick={() => setSelectedDays(30)}>
                  Last 30 days
                </button>
              </div>
            </div>
          </div>
        </div>

    <div className="card-body">
      <div className="table-responsive custom-table">
        <table className="table dataTable">
          <thead className="thead-light">
            <tr>
              <th>Bill No</th>
              <th>Party Name</th>
              <th>Date</th>
              <th>Net Total</th>
              {/* <th>User</th>
              <th>Status</th> */}
              {/* <th>Note</th> */}
              {/* <th>Voice Note</th> */}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={8} className="text-center">Loading...</td>
              </tr>
            ) : recentOrders.length > 0 ? (
              recentOrders.map((order, index) => (
                <tr key={index}>
                  <td>{order.billno}</td>
                  <td>{order.partyname}</td>
                  <td>{order.date1}</td>
                  <td>{order.net_total}</td>
                  {/* <td>{order.user}</td> */}
                  {/* <td>
                    <span
                      className="badge badge-pill badge-status"
                      style={{
                        backgroundColor: getStatusStyle(order.order_status),
                        color: "#fff",
                      }}
                    >
                      {order.order_status || "N/A"}
                    </span>
                  </td>
                  <td>{order.order_note || "—"}</td> */}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={8} className="text-center">No recent orders found.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
       

          {/* Pie Chart */}
          <div className="col-md-5 d-flex">
            <div className="card w-100">
              <div className="card-header border-0 pb-0">
                <h4>
                  <i className="ti ti-grip-vertical me-1" />
                  Orders By Stage
                </h4>
              </div>
              <div className="card-body">
                <Chart
                  options={chartOptions3.options}
                  series={chartOptions3.series}
                  type="pie"
                  width={chartOptions3.options.chart.width}
                  height={chartOptions3.options.chart.height}
                />
              </div>
            </div>
          </div>
        </div>

        {/* Area Chart */}
        <div className="row">
          <div className="col-md-12 d-flex">
            <div className="card w-100">
              <div className="card-header border-0 pb-0">
                <h4>
                  <i className="ti ti-grip-vertical me-1" />
                  Orders Completed in Months
                </h4>
              </div>
              <div className="card-body">
                <Chart
                  options={chartOptions4}
                  series={chartOptions4.series}
                  type="area"
                  height={chartOptions4.chart.height}
                />
              </div>
            </div>
          </div>
        </div>

        {/* Two Bar Charts */}
        <div className="row">
          {/* Bar Chart 1 */}
          <div className="col-md-6">
            <div className="card">
              <div className="card-header border-0 pb-0">
                <h4>
                  <i className="ti ti-grip-vertical me-1" />
                  Orders by Stage
                </h4>
              </div>
              <div className="card-body">
                <Chart
                  options={chartOptions}
                  series={chartOptions.series}
                  type="bar"
                  height={chartOptions.chart.height}
                />
              </div>
            </div>
          </div>

          {/* Bar Chart 2 */}
          <div className="col-md-6">
            <div className="card">
              <div className="card-header border-0 pb-0">
                <h4>
                  <i className="ti ti-grip-vertical me-1" />
                  Revenue by Category
                </h4>
              </div>
              <div className="card-body">
                <Chart
                  options={chartOptions2}
                  series={chartOptions2.series}
                  type="bar"
                  height={chartOptions2.chart.height}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderDashboard;

